declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export function trackSignupConversion() {
  window.gtag?.('event', 'conversion', {
    send_to: 'AW-18232739916/5kitCJbdx70cEMyQhvZD',
    value: 1.0,
    currency: 'SGD',
  });
}
